import axios from 'axios';
import vueTemp from "./vueTemp.js"


const service = axios.create({
  proxy: true,
  timeout: 200000,
  baseURL: getBaseUrl(),
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

service.interceptors.request.use(
  config => {
    let token = sessionStorage.getItem('token');
    let tenantId = sessionStorage.getItem('tenantId');
    if (token) {
      let tokenA = JSON.parse(token);
      config.headers.Authorization = tokenA.token;
    }
    if (tenantId) {
      config.headers.tenantId = tenantId;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  });

service.interceptors.response.use(
  response => response,
  error => {
    console.log('err' + error);
    let tenantId = sessionStorage.getItem('tenantId');
    if (error.response.status === 401) {
      window.location.href = "#/login" + "_" + tenantId;
    }
    if (error.response.status === 400) {
      vueTemp.$notify({title: '警告', message: error.response.data.errorMsg, type: 'warning'});
    }
    return Promise.reject(error)
  });

export default service



// WEBPACK FOOTER //
// ./src/common/request.js